module.exports = __webpack_public_path__ + "static/media/abrar.f2ee42b3.jpg";